import { createAsyncThunk } from "@reduxjs/toolkit";
import request from "../../../../service";
import { ILearningFormatCreate, ILearningFormatPayload } from "../types";
import {
    deletedLearningFormat,
    deletedRestoreFormat,
    setFormatRestoreData,
    setLearningFormat,
} from "./learningFormatSlice";
import { IErrorResponse, IRootState } from "../../../../types";

const GetLearningFormat = createAsyncThunk(
    "get/learning/format",
    async (_, { dispatch, rejectWithValue, getState }) => {
        try {
            const response = await request.get("/learning-formats");
            const lang = getState() as IRootState;
            const defaultLanguage = lang.languages.defaultLanguage;
            dispatch(setLearningFormat({ data: response.data, defaultLanguage }));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const CreateLearningFormat = createAsyncThunk(
    "create/learning/format",
    async (payload: ILearningFormatCreate, { rejectWithValue }) => {
        try {
            const response = await request.post("/learning-formats", payload);

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const DeleteLearningFormat = createAsyncThunk(
    "delete/learning/format",
    async (id: number, { rejectWithValue, dispatch }) => {
        try {
            const response = await request.delete(`/learning-formats/${id}`);

            dispatch(deletedLearningFormat(id));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const GetDeleteFormat = createAsyncThunk("get/delete/format", async (_, { dispatch, rejectWithValue }) => {
    try {
        const response = await request.get(`/learning-formats/deleted-items`);

        dispatch(setFormatRestoreData(response.data));

        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const RestoreDeleteFormat = createAsyncThunk(
    "restore/delete/format",
    async (id: number, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.post(`/learning-formats/restore/${id}`);

            dispatch(deletedRestoreFormat(id));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const EditLearningFormatData = createAsyncThunk(
    "edit/learning/format",
    async (data: ILearningFormatPayload, { rejectWithValue }) => {
        try {
            const response = await request.put(`/learning-formats/${data.id}`, data);

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

export {
    GetLearningFormat,
    CreateLearningFormat,
    DeleteLearningFormat,
    EditLearningFormatData,
    GetDeleteFormat,
    RestoreDeleteFormat,
};
